import { Selector } from '@reduxjs/toolkit';

import { NotificationState } from '@store/notificationWindow/notificationWindow.state';
import { State } from '@store/reducer';

export const getNotificationState: Selector<State, NotificationState> = (state) =>
  state.notification;
